import axios from 'axios';

const signInRequest = async (
  body,
  onSuccess = () => {},
  onFail = () => {},
) => {
  await axios.post('/partner/signin', body, {
    'Content-Type': 'application/json',
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onFail(error);
    });
};

export default signInRequest;
